{
    "NAME": "Linguaggio del database",
    "Database_Section_MaintenanceInterval_Title": "Intervallo di manutenzione del database",
    "Database_Section_MaintenanceInterval_Description": "Configura un periodo giornaliero durante il quale l'applicazione sospende l'attività del database. Gli orari di inizio e fine vengono interpretati come UTC.",
    "Database_Field_MaintenanceInterval_Enabled": "Sospendi l'attività del database giornalmente",
    "Database_Field_MaintenanceInterval_TimeStart": "Ora di inizio (UTC)",
    "Database_Field_MaintenanceInterval_TimeEnd": "Ora di fine (UTC)",
    "Database_Field_MaintenanceInterval_DaysOfWeek": "Giorni della settimana",
    "Database_Day_Monday": "Lunedi",
    "Database_Day_Tuesday": "Martedì",
    "Database_Day_Wednesday": "Mercoledì",
    "Database_Day_Thursday": "Giovedì",
    "Database_Day_Friday": "Venerdì",
    "Database_Day_Saturday": "Sabato",
    "Database_Day_Sunday": "Domenica",
    "Database_Action_Apply": "Fare domanda a",
    "Database_Action_Cancel": "Cancellare",
    "Database_Action_Refresh": "Rinfrescato",
    "Database_Save_Success": "Impostazioni del database salvate.",
    "Database_Save_Error": "Impossibile salvare le impostazioni del database.",
    "Database_Load_Error": "Impossibile caricare le impostazioni del database.",
    "Database_Warning_ReadOnly": "È possibile visualizzare queste impostazioni, ma non si dispone dell'autorizzazione per modificarle. Solo gli amministratori di sistema con accesso root possono modificare le impostazioni del database.",
    "Database_Warning_Unavailable": "Le impostazioni del database non sono attualmente disponibili. Il database potrebbe non essere stato accessibile all'avvio dell'applicazione."
}